export const PartyTagListResources = {
    getContent: {
      url: "/contents/party_tag_list",
      asyncActions: {
        init: "getPartyList_INIT",
        success: "getPartyList_SUCCESS",
        error: "getPartyList_ERROR"
      }
    }
  };
  
  const initialState = {
    partyList: undefined,
    links: undefined,
    status: undefined,
    statusText: undefined,
    meta: undefined,
    deleted: undefined,
    edited: undefined,
    hasList: undefined,
    loading: undefined,
    hasError: undefined
  };
  
  export function PartyTagList(state = { initialState }, action = {}) {
    const { init, success, error } = PartyTagListResources.getContent.asyncActions;
  
    switch (action.type) {
      case init: {
        return {
          ...state,
          loading: true,
          hasError: undefined
        };
      }
  
      case success: {
        const {
          data: {
            _jsonapi: { data },
            links,
            meta
          },
          status,
          statusText
        } = action.payload;
        return {
          partyList: data,
          links,
          status,
          statusText,
          meta,
          deleted: [],
          edited: [],
          hasList: true,
          loading: false,
          hasError: false
        };
      }
  
      case error: {
        return {
          ...state,
          loading: false,
          hasError: true
        };
      }
  
      default: {
        return state;
      }
    }
  }
  